export default "__VITE_ASSET__8875040f__"